import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BlobService {
  // No dependencies required for this service

  downloadBlobToClient(blob: Blob, fileName: string): void {
    if (!blob) {
      throw new Error('No data provided for download.');
    }

    if (!fileName) {
      throw new Error('No file name provided for download.');
    }

    const downloadUrl = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.setAttribute('style', 'display: none;');
    a.setAttribute('href', downloadUrl);
    a.setAttribute('download', fileName);

    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(downloadUrl);
  }
}
